// client/src/components/contratos/AssinarContratoModal.js
// Assinatura genérica do contrato (papel 'contraparte' por padrão) — mesmo
// endpoint que o mobile já usa (PUT /contratos/:id/assinar), agora também
// disponível no painel web. Nome/documento vêm pré-preenchidos a partir da
// contraparte cadastrada, mas ficam editáveis (cobre o caso de outra pessoa
// assinar na prática, ex.: um representante).
import React, { useRef, useState } from 'react';
import { Save, Loader2 } from 'lucide-react';
import FormModal from '../layout/FormModal';
import AssinaturaCanvas from '../common/AssinaturaCanvas';
import { useAssinarContrato } from '../../hooks/useContratos';
import useAlert from '../../hooks/useAlert';

const getContraparteNomeDocumento = (contrato) => {
    const c = contrato?.cliente;
    if (!c || typeof c !== 'object') return { nome: '', documento: '' };
    if (contrato.modeloContraparte === 'Fornecedor') {
        return { nome: c.nomeFantasia || c.razaoSocial || '', documento: c.documentoPrincipal || '' };
    }
    if (contrato.modeloContraparte === 'Transportador') {
        return {
            nome: c.nomeCompleto || c.razaoSocial || c.nomeFantasia || '',
            documento: c.tipoPessoa === 'Física' ? (c.cpf || '') : (c.cnpj || ''),
        };
    }
    return { nome: c.user?.name || c.nome || '', documento: c.user?.cpf || '' };
};

const AssinarContratoModal = ({ contrato, onClose }) => {
    const { setAlert } = useAlert();
    const assinarContrato = useAssinarContrato();
    const canvasRef = useRef(null);

    const contraparte = getContraparteNomeDocumento(contrato);
    const [nomeAssinante, setNomeAssinante] = useState(contraparte.nome);
    const [documentoAssinante, setDocumentoAssinante] = useState(contraparte.documento);
    const [observacoes, setObservacoes] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const assinatura = canvasRef.current?.getSignature();
        if (!assinatura) {
            setAlert('Colete a assinatura no campo indicado antes de confirmar.', 'warning');
            return;
        }

        assinarContrato.mutate(
            { id: contrato._id, assinatura, papel: 'contraparte', nomeAssinante, documentoAssinante, observacoes },
            { onSuccess: onClose }
        );
    };

    return (
        <FormModal title={`Assinar Contrato Nº ${contrato.numeroContrato}`} onClose={onClose}>
            <form onSubmit={handleSubmit}>
                <div className="form-grid-container-cols-2">
                    <div className="form-group">
                        <label className="form-label">Nome de quem assina</label>
                        <input type="text" className="form-input" value={nomeAssinante} onChange={(e) => setNomeAssinante(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label className="form-label">CPF/CNPJ de quem assina</label>
                        <input type="text" className="form-input" value={documentoAssinante} onChange={(e) => setDocumentoAssinante(e.target.value)} />
                    </div>
                </div>

                <div className="form-group full-width">
                    <label className="form-label">Assinatura*</label>
                    <AssinaturaCanvas ref={canvasRef} />
                </div>

                <div className="form-group full-width">
                    <label className="form-label">Observações (opcional)</label>
                    <textarea className="form-input" rows={2} value={observacoes} onChange={(e) => setObservacoes(e.target.value)} />
                </div>

                <div className="form-actions">
                    <button type="button" onClick={onClose} className="action-button action-button-secondary">Cancelar</button>
                    <button type="submit" disabled={assinarContrato.isPending} className="action-button action-button-primary">
                        {assinarContrato.isPending ? <Loader2 size={18} className="animate-spin icon" /> : <Save size={18} className="icon" />}
                        Confirmar Assinatura
                    </button>
                </div>
            </form>
        </FormModal>
    );
};

export default AssinarContratoModal;
